import { createAction } from '@/utility/actions';

import {
  APPS_GET,
  APPS_TOP_GET,
  APPS_GET_FILTERS,
  APPS_AUTOCOMPLETE,
  APPS_SET_AUTOCOMPLETE_DEF_DATA,
} from './types';

/**
 * getApps - params: data(dma_id_fk | search | filters | partner)
 */
export const getApps = createAction(APPS_GET);

/**
 * getAppsTop - params: data(dma_id_fk | partner)
 */
export const getAppsTop = createAction(APPS_TOP_GET);

export const getAppsFilters = createAction(APPS_GET_FILTERS);

/**
 * appsAutocomplete - params: data(dma_id_fk | search)
 */
export const appsAutocomplete = createAction(APPS_AUTOCOMPLETE);

/**
 * appsSetAutocompleteDefData
 */
export const appsSetAutocompleteDefData = createAction(APPS_SET_AUTOCOMPLETE_DEF_DATA);

export default {
  getApps,
  getAppsTop,
  getAppsFilters,
  appsAutocomplete,
  appsSetAutocompleteDefData,
};
